<template>
  <div class="change-comparison-card">
    <span title="同比增长率=（本期数-同期数）/ 同期数" class="label">{{name}}</span>
    <span class="value">{{value}}</span>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    value: String
  },
  data() {
    return {

    }
  },
  components: {

  }
}
</script>
